module.exports = __webpack_public_path__ + "static/media/LogoOnlineTesting.54e2412b.svg";